<div class="container  mt-2">


    <h3 i18n class="text-left">My Wishlist</h3>
    <div style="min-height: 400px;margin-top: 20px;">
        <div>

            <div *ngIf="((wishlist?.items.length <= 0) && isLoading == false)" i18n>There are currently no items in your
                wishlist.
            </div>
        </div>

        <ul *ngIf="(wishlist?.items.length > 0) ">
            <li *ngFor="let item of wishlist.items">
                <div class="card">
                    <div class="d-flex">

                        <div class="p-4">
                            <img src="{{'https://alarabiya.com.kw/' + 'pub/media/catalog/product/' + item.product.custom_attributes[0].value}}"
                                 width="90" height="90">
                        </div>

                        <div class="flex-grow-1">
                            <div class="row">
                                <div class="col-12 text-left"><b i18n>Name:</b><span
                                        class="text-left">{{item.product.name}}</span> </div>
                            </div>

                            <div class="row">
                                <div class="col-12 text-left"><b i18n>Price:</b>
                                    <p class="text-left" style="font-weight:700 ; color: #17929e">{{item.product.price}}
                                        KWD</p></div>
                            </div>

                            <span class="badge badge-info p-2" style="cursor:pointer;background-color: #f0f0f0; color:black;"  (click)="deleteItemFromWishlist(item)"><i class="fa fa-trash" ></i> Remove from wishlist</span>
                        </div>

                        <span class="text-right">
                        <button class="btn btn-primary pull-right" (click)="goToProductDetails(item.product.sku)"
                        > Buy Now
                        </button>
                        </span>
                    </div>
                </div>

            </li>
        </ul>


        <!--        <ul *ngIf="(wishlist?.items.length > 0) ">-->

        <!--            <li *ngFor="let item of wishlist.items">-->
        <!--                <div class="card">-->
        <!--                <div class="row">-->
        <!--                    <div class="col-2">-->
        <!--                        <img src="{{'https://alarabiya.com.kw/' + 'pub/media/catalog/product/' + item.product.custom_attributes[0].value}}" width="90" height="90">-->
        <!--                    </div>-->
        <!--                    <div class="col-10">-->
        <!--                        <span class="text-left">{{item.product.name}}</span> <span class="pull-right"><i class="fa fa-trash" (click)="deleteItemFromWishlist(item)"></i></span>-->
        <!--                        <p class="text-left" style="font-weight:700 ; color: #17929e">{{item.product.price}} KWD</p>-->
        <!--                        <span class="pull-left">  <button class="btn btn-primary" (click)="goToProductDetails(item.product.sku)" style="padding-right: 20px ; padding-left: 20px" > Buy Now</button>  </span>-->

        <!--&lt;!&ndash;                        <div class="col-1 pull-left">&ndash;&gt;-->
        <!--&lt;!&ndash;                            <i style="font-size: 30px;color:rgba(232,14,0,0.86)" class="fa fa-heart text-left"></i>&ndash;&gt;-->
        <!--&lt;!&ndash;                        </div>&ndash;&gt;-->

        <!--&lt;!&ndash;                        <div  class="col-11 pull-right">&ndash;&gt;-->
        <!--&lt;!&ndash;                            <div class="row">&ndash;&gt;-->
        <!--&lt;!&ndash;                                <div class="col-12">&ndash;&gt;-->

        <!--&lt;!&ndash;                                    <div class="row">&ndash;&gt;-->
        <!--&lt;!&ndash;                                        <div class="col-12 text-left"><span style="padding: 5px;color: #0c0c0c">  <b i18n>Name:</b> {{item.product.name}}  </span></div>&ndash;&gt;-->
        <!--&lt;!&ndash;                                    </div>&ndash;&gt;-->

        <!--&lt;!&ndash;                                                            <div class="row">&ndash;&gt;-->
        <!--&lt;!&ndash;                                                                <div class="col-12">&ndash;&gt;-->
        <!--&lt;!&ndash;                                                                    <span class="pull-left pl-4" style="font-size: 15px"> <b i18n>Price:</b> {{item.product.price}}</span>&ndash;&gt;-->
        <!--&lt;!&ndash;                                                                <span class="pull-right">  <i class="fa fa-trash" (click)="deleteItemFromWishlist(item)"></i><button class="btn btn-primary" (click)="goToProductDetails(item.product.sku)" style="padding-right: 20px ; padding-left: 20px" > Buy Now</button>  </span>&ndash;&gt;-->

        <!--&lt;!&ndash;                                                            </div>&ndash;&gt;-->
        <!--&lt;!&ndash;                                                            </div>&ndash;&gt;-->

        <!--&lt;!&ndash;                                </div>&ndash;&gt;-->
        <!--&lt;!&ndash;                            </div>&ndash;&gt;-->
        <!--&lt;!&ndash;                        </div>&ndash;&gt;-->
        <!--                    </div>-->
        <!--                </div>-->


        <!--&lt;!&ndash;                <div class="row">&ndash;&gt;-->

        <!--&lt;!&ndash;                    <div class="col-12">&ndash;&gt;-->
        <!--&lt;!&ndash;                        <div class="row">&ndash;&gt;-->
        <!--&lt;!&ndash;                            <div class="col-12 ">&ndash;&gt;-->
        <!--&lt;!&ndash;                                <span class="pull-left">&ndash;&gt;-->
        <!--&lt;!&ndash;                                    <i style="font-size: 20px;color:rgba(232,14,0,0.86)" class="fa fa-heart text-left"> <span style="padding: 5px;color: #0c0c0c">{{item.product.name}}</span> </i>&ndash;&gt;-->

        <!--&lt;!&ndash;                                </span>&ndash;&gt;-->
        <!--&lt;!&ndash;                            </div>&ndash;&gt;-->
        <!--&lt;!&ndash;                        </div>&ndash;&gt;-->

        <!--&lt;!&ndash;                        <div class="row">&ndash;&gt;-->
        <!--&lt;!&ndash;                            <div class="col-12">&ndash;&gt;-->
        <!--&lt;!&ndash;                                <span class="pull-left pl-4" style="font-size: 15px"> <b i18n>Price:</b> {{item.product.price}}</span>&ndash;&gt;-->
        <!--&lt;!&ndash;                            <span class="pull-right"><button class="btn btn-primary" (click)="goToProductDetails(item.product.sku)" style="padding-right: 20px ; padding-left: 20px" > Buy Now</button>  </span>&ndash;&gt;-->

        <!--&lt;!&ndash;                        </div>&ndash;&gt;-->
        <!--&lt;!&ndash;                        </div>&ndash;&gt;-->


        <!--&lt;!&ndash;                    </div>&ndash;&gt;-->
        <!--&lt;!&ndash;                </div>&ndash;&gt;-->

        <!--                </div>-->
        <!--            </li>-->

        <!--        </ul>-->

    </div>
</div>

